import { render } from "../views/chat.html?vue&type=template&id=2d07cb3a&ts=true&external"
import script from "../scripts/chat.ts?vue&type=script&lang=ts&external"
export * from "../scripts/chat.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/chat-messages.css?vue&type=style&index=0&lang=css&external"
import "../css_builds/components/chat-bubbles.css?vue&type=style&index=1&lang=css&external"
import "../css_builds/components/buttons.css?vue&type=style&index=2&lang=css&external"
import "../css_builds/components/media.css?vue&type=style&index=3&lang=css&external"
import "../css_builds/components/timestamp.css?vue&type=style&index=4&lang=css&external"
import "../css_builds/components/message-feedback.css?vue&type=style&index=5&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d07cb3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d07cb3a', __exports__)) {
    api.reload('2d07cb3a', __exports__)
  }
  
  module.hot.accept("../views/chat.html?vue&type=template&id=2d07cb3a&ts=true&external", () => {
    api.rerender('2d07cb3a', render)
  })

}


export default __exports__